<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <b-row v-bind:class="[{ busy: busy}, 'opacity-transition']">
        <pb-spinner v-if="busy"></pb-spinner>
        <b-col>
            <b-row>
                <b-col>
                    <b-form-group
                            label="Season"
                            label-for="selectSeason">
                        <v-select
                                :reduce="season => season.id"
                                @input="selectSeason"
                                id="selectSeason"
                                v-model="tile.season"
                                :options="seasons">
                        </v-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <tile :article-list="articleList" :variant-func="variantFunc" :tile="tile" @input="tile = $event.target.value"></tile>
        </b-col>

    </b-row>
</template>

<script>
    import ArticleApi from "@shared/_api/article";
    import Tile from "./designShop/Tile";

    export default {
        name: 'pb-design-shop-tile',
        props: ['placeholder', 'label', 'name', 'value'],
        components: {'tile': Tile},
        data() {
            return {
                busy: false,
                articleList: [],
                seasons: [
                    {id: 'winter', label: 'Winter'},
                    {id: 'summer', label: 'Summer'},
                    {id: 'all', label: 'All'},
                ],
                tile: this.value ? this.value : {
                    pinList: [],
                    image: null,
                    season: '',
                    type: 'article'
                }
            };
        },
        created() {
            this.busy = true;
            ArticleApi.articleList().then((articleList) => {
                this.articleList = this.$_.uniqBy(articleList, 'id');
            }).finally(() => {
                this.busy = false;
            });
        },
        methods: {
            selectSeason(season) {
                this.tile.season = season;
            },
            variantFunc(article) {
                let result = [],
                    articleColors = this.$_.uniqWith(article.variantList.map(variant => variant.articleColor), this.$_.isEqual);

                for (const color of articleColors) {
                    let variantImages = article.articleImageList ? article.articleImageList.filter(img => (Number(img.colorId) === color.id)) : new Array(1).fill({image: article.webImage || article.image});

                    for (const variantImage of variantImages) {
                        result.push({
                            id: article.id,
                            colorId: color.id,
                            thumbnail: variantImage.media,
                            description: article.primaryDescription || article.secondaryDescription,
                            label: article.name + " " + color.value,
                            metaLabel: null
                        });
                    }
                }

                return result;
            }
        },
        watch: {
            value: function (val) {
                this.tile = val;
            },
            tile: {
                handler(val) {
                    this.$emit('input', val);
                },
                deep: true
            }
        },

    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    .pin-img-stage {
        position: relative;
        display: inline-block;

        .pin-container {
            position: absolute;
        }

        .pin {
            cursor: pointer;
            width: 25px;
            height: 25px;
            background-color: white;
            border-radius: 50%;
            box-shadow: 0 2px 30px 0 #4A4B4D;
            text-align: center;
            z-index: 999;
        }

        .pin-info {
            color: white;
            position: absolute;
            top: -20px;
            left: 20px;

            button {
                color: white;
            }
        }

        img {
            max-width: 100%;
            display: block;
            margin: auto;
            object-fit: cover;
        }
    }

    .article-select {
        position: absolute;
    }


</style>
